module.exports = __webpack_public_path__ + "static/media/profile.80082d1d.png";